module.exports = __webpack_public_path__ + "static/media/Theatre.88e22d00.svg";